/* eslint-disable default-case */
import React, { useEffect, useState, useCallback } from "react";
import { message } from "antd";
import "./style.css";
import "antd/dist/antd.css";
// Bước 1 gới thiệu
import Introduce from "./page/1-introduce";
// Bước 2 chọn quyền lợi bảo hiểm
import Benefits from "./page/2-InsuranceBenefits";
// Bước 3 thông tin người mua và thêm người được BH
import BuyerInfo from "./page/3-buyerInformation";
// Bước 4 xem lại thông tin và tạo đơn
import Create from "./page/4-Create";
import History from "./../../routes/history";
import helper_center from "./../../extra/helper";
import Service from "./../../extra/getAPI";
import IDong from "./../../assets/suc-khoe-vang/iDong.png";
import IBac from "./../../assets/suc-khoe-vang/iBac.png";
import ITitan from "./../../assets/suc-khoe-vang/iTitan.png";
import IVang from "./../../assets/suc-khoe-vang/iVang.png";
import IBachkim from "./../../assets/suc-khoe-vang/iBachkim.png";
import IKimcuong from "./../../assets/suc-khoe-vang/iKimcuong.png";
export const AuthContext = React.createContext();

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

const Index = () => {
  const [step, setStep] = useState(1);
  const platform = helper_center.getParamUrlByKey("platform");
  //Thông tin bảo hiểm từ bước 1 đến bước 4
  const [dataIsu, setDataIsu] = useState({ vat: 1 });
  // Data dùng để lấy phí
  const [dataGetFees, setDataGetFees] = useState({});
  // Thông tin người được bảo hiểm
  const [insuredPerson, setInsuredPerson] = useState({});
  // Danh sách người được bảo hiểm
  const [listIsu, setListIsu] = useState([]);
  // Data thông tin bảo hiểm của luồng mua lại
  const [dataIsuBuyBack, setDataIsuBuyBack] = useState({});
  // Danh sách người được bảo hiểm cho luồng mua lại
  const [acquisitionList, setAcquisitionList] = useState([]);
  const [indexEdit, setIndexEdit] = useState(null);
  // link chử ký
  const [linkIMG, setLinkIMG] = useState({});
  // Phí bảo hiểm 1 người
  const [fees, setFees] = useState({});
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  // phí hoa hồng
  const [commission, setCommission] = useState();
  // khoản trợ giá
  const [subsidyAmount, setSubsidyAmount] = useState(0);
  const [vat, setVAT] = useState({});

  const goStep = (step) => {
    setStep(step);
  };

  const PageView = () => {
    switch (step) {
      case 1:
        return <Introduce />;
      case 2:
        return <Benefits />;
      case 3:
        return <BuyerInfo />;
      case 4:
        return <Create />;
    }
  };

  const _render_quan_he = (value) => {
    switch (value) {
      case 1:
        return "Bản thân";
      case 2:
        return "Vợ/Chồng";
      case 3:
        return "Con hợp pháp";
      case 4:
        return "Ba ruột/ Mẹ ruột";
      case 5:
        return "Anh/Chị/Em ruột";
      default:
        break;
    }
  };

  // Thêm xoá sửa danh sách người bao hiểm
  const ActionList = (action, index, value) => {
    let listIsured = [...listIsu];
    switch (action) {
      case "unshift":
        listIsured.unshift({ ...value });
        setListIsu([...listIsured]);
        setDataGetFees({ ...dataIsu });
        localStorage.setItem("listInsuredVBICare", JSON.stringify(listIsured));
        MessageSucc("Thêm người được bảo hiểm thành công!");
        window.scrollTo(2000, 2000);
        break;
      case "delete":
        listIsured.splice(index, 1);
        setListIsu([...listIsured]);
        setDataGetFees({ ...dataIsu });
        localStorage.setItem("listInsuredVBICare", JSON.stringify(listIsured));
        break;
      case "deleteBuyer":
        listIsured.concat({ ...value });
        setListIsu([...listIsured]);
        setDataGetFees({ ...dataIsu });
        localStorage.setItem("listInsuredVBICare", JSON.stringify(listIsured));
        break;
      case "deleteParent":
        listIsured = listIsured.filter((v) => Number(v.relationshipWithBuyerName) === 1);
        setListIsu([...listIsured]);
        setDataGetFees({ ...dataIsu });
        localStorage.setItem("listInsuredVBICare", JSON.stringify(listIsured));
        break;
      case "addBuyer":
        listIsured.concat({ ...value });
        setListIsu([...listIsured]);
        setDataGetFees({ ...dataIsu })
        localStorage.setItem("listInsuredVBICare", JSON.stringify(listIsured));
        MessageSucc("Thêm người được bảo hiểm thành công!");
        window.scrollTo(2000, 2000);
        break;
      case "add":
        listIsured.push({ ...value });
        setListIsu([...listIsured]);
        setDataGetFees({ ...dataIsu })
        localStorage.setItem("listInsuredVBICare", JSON.stringify(listIsured));
        MessageSucc("Thêm người được bảo hiểm thành công!");
        window.scrollTo(2000, 2000);
        break;
      case "edit":
        listIsured[index] = { ...value };
        setListIsu([...listIsured]);
        setDataGetFees({ ...dataIsu })
        localStorage.setItem("listInsuredVBICare", JSON.stringify(listIsured));
        if (step > 2) {
          MessageSucc("Cập nhật thành công!");
          window.scrollTo(2000, 2000);
        }
        break;
    }
  };

  const getListIsu = (values, listIsu) => {
    let arrInsu = [];
    if (listIsu.length === 0) {
      return [
        {
          insuredName: values?.buyerName,
          relationshipWithBuyer: {
            id: 1,
            title: "Bản thân",
          },
          insuredDob: values?.dob.split("/").reverse().join("-"),
          insuredGender: values?.buyerGender,
          additional: {
            additional_01:
              values?.additional_01 === 1 || values?.additional_01?.[0] === 1
                ? 1
                : 2,
            additional_02:
              values?.additional_02 === 1 || values?.additional_02?.[0] === 1
                ? 1
                : 2,
            additional_03:
              values?.additional_03 === 1 || values?.additional_03?.[0] === 1
                ? 1
                : 2,
            additional_04:
              values?.additional_04 === 1 || values?.additional_04?.[0] === 1
                ? 1
                : 2,
          },
        },
      ];
    }
    listIsu.map(
      (v) => {
        let additional = getAdditional(values, v)
        arrInsu = [
          ...arrInsu,
          {
            insuredName: v?.insuredName,
            relationshipWithBuyer: {
              id: v?.relationshipWithBuyerName,
              title: _render_quan_he(v?.relationshipWithBuyerName),
            },
            insuredDob: v?.insuredDob?.split("/").reverse().join("-"),
            insuredPrivateId: v?.insuredPrivateId,
            insuredGender: v?.insuredGender,
            insuredPhone: v?.insuredPhone,
            insuredEmail: v?.insuredEmail,
            insuredAddress: v?.permanentAddress,
            additional: additional,
          },
        ]
      }

    );
    return arrInsu;
  };

  // Lấy phí bảo hiểm
  const getFees = (values, listIsu) => {
    // (
    //   formData?.buyerGender === 2 &&
    //   (+dob.tuoi < 19 || +dob?.tuoi > 50)
    // )
    setLoading(true);
    const data = {
      insuredInfo: {
        buyerName: values?.buyerName,
        buyerDob: (dataIsu?.buyerDob || values?.dob).split("/").reverse().join("-"),
        buyerGender: values?.buyerGender,
        package: values?.packageId,
      },
      listOfInsuredPeople: getListIsu(values, listIsu),
    };
    Service.apicallNoBase64("POST", `/api/v1/product/vbi-care/config`, data)
      .then((res) => {
        setLoading(false);
        if (res?.data?.statusCode === 200) {
          setPackages(res?.data?.result);
        } else {
          // MessageErr("Không tìm thấy gói bảo hiểm phù hợp!");
          setPackages([]);
        }
      })
      .catch((err) => {
        // MessageErr("Không tìm thấy gói bảo hiểm phù hợp!");
        setLoading(false);
        setPackages([]);
      });
  };

  // Check thoả các điều kiện và gọi lại api lấy phí bảo hiểm
  const getAdditional = (dataGetFees, value) => {
    const additional = {
      additional_01:
        dataGetFees?.additional_01 === 1 || dataGetFees?.additional_01?.[0] === 1
          ? 1
          : 2,
      additional_02:
        dataGetFees?.additional_02 === 1 || dataGetFees?.additional_02?.[0] === 1
          ? 1
          : 2,
      additional_03:
        dataGetFees?.additional_03 === 1 || dataGetFees?.additional_03?.[0] === 1
          ? 1
          : 2,
      additional_04:
        dataGetFees?.additional_04 === 1 || dataGetFees?.additional_04?.[0] === 1
          ? 1
          : 2,
      // additional_05: 1,
    }
    // Nếu giới tính là nam thì ko mua thai sản
    if (value?.insuredGender === 1) {
      additional.additional_01 = 2
      return additional
    } else {
      // Nếu là nữ ko nằm trong độ tuổi 19 - 50
      if (
        helper_center._calculateAge(value?.insuredDob) < 19 ||
        helper_center._calculateAge(value?.insuredDob) > 50
      ) {
        additional.additional_01 = 2
        return additional
      } else {
        return additional
      }
    }
  };

  useEffect(() => {
    !localStorage.getItem("hardreset_1") && localStorage.clear();
    localStorage.setItem("hardreset_1", true);
    const dataGetFeesVbiCare = JSON.parse(
      localStorage.getItem("dataGetFeesVbiCare")
    );
    if (
      dataGetFeesVbiCare?.dob &&
      dataGetFeesVbiCare?.buyerGender &&
      dataGetFeesVbiCare?.buyerName
    ) {
      setDataGetFees(dataGetFeesVbiCare);
    }
  }, []);

  const deboundGetFees = useCallback(
    debounce((n, l) => {
      checkGetFees(n, l)
    }, 500), [])

  useEffect(() => {
    deboundGetFees(dataGetFees, listIsu)
  }, [dataGetFees]);


  const checkGetFees = (dataGetFees, listIsu) => {
    if ((dataGetFees.buyerdob || dataGetFees.dob) && dataGetFees.buyerGender) {
      getFees(dataGetFees, listIsu);
      localStorage.setItem("dataGetFeesVbiCare", JSON.stringify(dataGetFees));
    }
  };

  const OpenLink = (link) => {
    if (platform === "app") {
      window.ReactNativeWebView.postMessage(`/gotoBrownser?link=${link}`);
      return;
    }
    window.open(link, "_blank");
  };

  const uploadG2 = (file, name, nameFile) => {
    MessageWarning("Chữ ký đang được xử lý!");
    var form = new FormData();
    const timestamp = +new Date();
    form.append("storage", "s3");
    form.append("file", file);
    form.append("path", `/user/${nameFile}/${timestamp}-${name}`);
    Service.apicall_upload_G2("POST", `/upload`, form)
      .then((res) => {
        let data = res?.data;
        if (data?.complete) {
          MessageSucc("Ký tên thành công.");
          setLinkIMG({
            ...linkIMG,
            signature: data?.link,
          });
        } else {
          MessageErr("Ký tên lỗi vui lòng ký lại.");
        }
      })
      .catch((err) => {
        MessageErr("Ký tên lỗi vui lòng ký lại.");
      });
  };

  // Thông báo lỗi dủng chung cho các page
  const MessageErr = (content) => {
    message.error(
      {
        content: content,
        style: {
          marginTop: "25px",
        },
      },
      15
    );
  };

  // Thông báo lỗi dủng chung cho các page
  const MessageWarning = (content) => {
    message.warning(
      {
        content: content,
        style: {
          marginTop: "25px",
        },
      },
      15
    );
  };

  // Thông báo thành công dủng chung cho các page
  const MessageSucc = (content) => {
    message.success(
      {
        content: content,
        style: {
          marginTop: "25px",
        },
      },
      15
    );
  };

  const arrItem = [
    {
      id: 1,
      title: "Gói Đồng",
      fee: packages[0]?.fees,
      icon: IDong,
      insuranceMoney: packages[0]?.price,
    },
    {
      id: 2,
      title: "Gói Bạc",
      fee: packages[1]?.fees,
      icon: IBac,
      insuranceMoney: packages[1]?.price,
    },
    {
      id: 3,
      title: "Gói Titan",
      fee: packages[2]?.fees,
      icon: ITitan,
      insuranceMoney: packages[2]?.price,
    },
    {
      id: 4,
      title: "Gói Vàng",
      fee: packages[3]?.fees,
      icon: IVang,
      insuranceMoney: packages[3]?.price,
    },
    {
      id: 5,
      title: "Gói Bạch Kim",
      fee: packages[4]?.fees,
      icon: IBachkim,
      insuranceMoney: packages[4]?.price,
    },
    {
      id: 6,
      title: "Gói Kim Cương",
      fee: packages[5]?.fees,
      icon: IKimcuong,
      insuranceMoney: packages[5]?.price,
    },
  ];

  return (
    <AuthContext.Provider
      value={{
        MessageErr,
        OpenLink,
        goStep,
        dataIsu,
        setDataIsu,
        ActionList,
        listIsu,
        setListIsu,
        insuredPerson,
        setInsuredPerson,
        indexEdit,
        setIndexEdit,
        _render_quan_he,
        linkIMG,
        setLinkIMG,
        uploadG2,
        fees,
        setFees,
        getFees,
        acquisitionList,
        setAcquisitionList,
        dataIsuBuyBack,
        setDataIsuBuyBack,
        vat,
        setVAT,
        packages,
        arrItem,
        dataGetFees,
        setDataGetFees,
        loading,
        commission,
        setCommission,
        subsidyAmount,
        setSubsidyAmount,
        getAdditional
      }}
    >
      <div style={{ maxWidth: 800, margin: "0px auto", color: "#343A40" }}>
        {PageView()}
      </div>
    </AuthContext.Provider>
  );
};

export default Index;
